(function ($) {

	const RECAPTCHA_TOKEN_KEY = "recaptcha_token";

	/**
	 * Append reCAPTCHA token to various data types.
	 *
	 * @param {object|Array|string|FormData} data - The data to which the token should be appended.
	 * @param {string} token - The reCAPTCHA token to append.
	 * @returns {object|Array|string|FormData} - The updated data with the token appended.
	 */
	function appendRecaptchaToken(data, token) {
		switch (true) {
			case data instanceof FormData:
				data.append(RECAPTCHA_TOKEN_KEY, token);
				break;
			case Array.isArray(data):
				data.push({
					name: RECAPTCHA_TOKEN_KEY,
					value: token,
				});
				break;
			case typeof data === "string":
				const dataObject = queryStringToObject(data);
				dataObject[RECAPTCHA_TOKEN_KEY] = token;
				return objectToQueryString(dataObject);
			case typeof data === "object":
				data[RECAPTCHA_TOKEN_KEY] = token;
				break;
			default:
				console.warn("Unhandled data type:", typeof data);
		}
		return data;
	}

	/**
	 * Convert a query string to an object.
	 *
	 * @param {string} query - The query string to be converted.
	 * @returns {object} - The resulting object with key-value pairs.
	 */
	function queryStringToObject(query) {
		const params = new URLSearchParams(query),
			result = {};

		for (const [key, value] of params.entries()) {
			result[key] = value;
		}

		return result;
	}

	/**
	 * Convert an object to a query string.
	 *
	 * @param {object} obj - The object to be converted.
	 * @returns {string} - The resulting query string.
	 */
	function objectToQueryString(obj) {
		return new URLSearchParams(obj).toString();
	}

	/**
	 * Perform AJAX request with reCAPTCHA token inclusion.
	 *
	 * @param {object} settings - The settings object for the AJAX request.
	 * @param {string} [action='contact_form'] - The action for the reCAPTCHA execution.
	 */
	$.ajaxWithRecaptcha = function (settings, action = "contact_form") {
		// Get reCAPTCHA token
		grecaptcha.ready(function () {
			grecaptcha.execute(recaptcha.siteKey, {action: action}).then(function (token) {
				// Handle different data types and append the token
				settings.data = appendRecaptchaToken(settings.data, token);

				// Perform AJAX request
				$.ajax(settings);
			});
		});
	};

	/**
	 * Original code to refresh reCAPTCHA token and update input field.
	 */
	jQuery(document).ready(function ($) {

		function refreshRecaptchaToken() {
			grecaptcha.ready(function () {
				grecaptcha.execute(recaptcha.siteKey, {action: "contactform"}).then(function (token) {
					const recaptchaInput = $("input[name=\"recaptcha\"]");
					if (recaptchaInput.length > 0) {
						recaptchaInput.val(token);
					}
				});
			});
		}

		// Refresh the reCAPTCHA token every 30 minutes
		const refreshInterval = 30 * 60 * 1000; // 30 minutes in milliseconds
		setInterval(refreshRecaptchaToken, refreshInterval);

		grecaptcha.ready(function () {
			refreshRecaptchaToken(); // Initial token generation
		});

	});

})(jQuery);
